import Box from '@nubank/nuds-web/components/Box/Box';
import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';

import Transparency from '../Account/patterns/Card/Transparency';

function GAT() {
  return (
    <ParallaxProvider>
      <Box
        marginTop={{ xs: 'auto', md: '16x', lg: '0x' }}
        paddingTop={{ xs: 'auto', md: '80px', lg: '6x' }}
        marginBottom={{ xs: '8x', md: '12x', lg: '16x' }}
      >
        <Transparency />
      </Box>
    </ParallaxProvider>
  );
}

export default GAT;
